import {Node} from 'prosemirror-model'
import {Plugin, SelectionRange} from 'prosemirror-state'
import {Decoration, DecorationSet} from 'prosemirror-view'

import {schema} from '../schema/hybrid-markdown-schema'
import styles from './hybrid-block.module.css'

/**
 * Determines if a selection range has any overlap with a node. Will return true if the range is fully inside the node,
 * fully surrounds the node, or starts or ends in the node.
 */
function overlapsNode(range: SelectionRange, nodePos: number, nodeLength: number): boolean {
  const rangeStart = range.$from.pos
  const rangeEnd = range.$to.pos
  const nodeEnd = nodePos + nodeLength
  return (
    (rangeStart >= nodePos && rangeStart < nodeEnd) ||
    (rangeEnd > nodePos && rangeEnd <= nodeEnd) ||
    (rangeStart < nodePos && rangeEnd > nodeEnd)
  )
}

function decorateActiveNodes(doc: Node, selection?: SelectionRange): DecorationSet {
  const decorations: Decoration[] = []

  if (selection)
    doc.descendants((node, pos) => {
      if (node.type === schema.nodes.document) return
      const isSelected = overlapsNode(selection, pos, node.nodeSize)

      if (isSelected) {
        decorations.push(
          Decoration.node(pos, pos + node.nodeSize, {
            class: styles.activeBlock,
          }),
        )
      }
    })

  return DecorationSet.create(doc, decorations)
}

/** Adds the `.activeBlock` class to active hybrid block nodes. */
export const decorateActiveHybridBlocksPlugin = () =>
  new Plugin({
    state: {
      init(_, {doc, selection}) {
        return decorateActiveNodes(doc, selection.ranges[0])
      },
      apply({doc, selection}) {
        // TODO: can we only update if the selection has changed?
        return decorateActiveNodes(doc, selection.ranges[0])
      },
    },
    props: {
      decorations(state) {
        return this.getState(state)
      },
    },
  })
